export default __webpack_public_path__ + "static/media/polaroid4.b8c76875.jpg";